var render = function render(_c,_vm){return _c('img',{attrs:{"src":require("../maarima/images/maarima_logo.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }